import { BitriseProfile } from '@trace/types';
import React, { createContext, FunctionComponent } from 'react';
import { AuthenticationState } from './useAuthentication';
import useAuthenticationBitrise from './useAuthenticationBitrise';
import Error401 from '../Error/Error401';
import PageLoad from '../Page/PageLoad';

export const AuthContextBitrise = createContext<AuthenticationState<BitriseProfile>>({
  data: {
    avatar_url: '',
    created_at: '',
    data_id: 0,
    email: '',
    has_used_organization_trial: false,
    slug: '',
    username: '',
  },
  isAuthenticating: true,
  isTokenValid: false,
  token: '',
});

const AuthenticateBitrise: FunctionComponent = (props) => {
  const auth = useAuthenticationBitrise();

  if (auth.isAuthenticating) {
    return <PageLoad />;
  }

  if (!auth.isTokenValid) {
    return <Error401 />;
  }

  return <AuthContextBitrise.Provider {...props} value={auth} />;
};

export default AuthenticateBitrise;
